import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import HTTPSredirect from 'react-https-redirect';
import './index.css';
import './ws';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <HTTPSredirect>
    <Provider store={store}>
      <App />
    </Provider>
  </HTTPSredirect>
);
